import {SettingOutlined} from '@ant-design/icons';

export const title = '系統管理';

export const icon = <SettingOutlined />;
export default () => null;
